import * as DbTypes from "../types/shared-dbtypes";
import { Lazy } from "../core/lazy";
import { ServiceProvider } from "../core/provider/service-provider";
import { UrlHelper } from "../core/html/url-helper";
import { MessageHelper } from "../helper/message-helper";
import { DateHelper } from "../helper/date-helper";
import { UserHelper } from "../core/user-helper";

export class ConnectionInformationVm {
	public static getInstance = Lazy.singleton(ConnectionInformationVm);

	constructor() {
		this.name = ko.observable(null);
		this.webServer = ko.observable(null);
		this.datasource = ko.observable(null);
		this.catalog = ko.observable(null);
		this.catalogVersion = ko.observable(null);
		this.user = ko.observable(null);
		this.marketer = ko.observable(null);
		this.marketerKey = ko.observable(null);
		this.backup = ko.observable(null);
		this.backupDate = ko.observable(DateHelper.nowAsDateWithTime());
		this.isTestEnvironment = ko.observable(false);
		this.colorValue1 = ko.observable(0);
		this.colorValue2 = ko.observable(0);
		this.color1 = ko.observable(null);
		this.color2 = ko.observable(null);
	}

	public name: KnockoutObservable<string>;
	public webServer: KnockoutObservable<string>;
	public datasource: KnockoutObservable<string>;
	public catalog: KnockoutObservable<string>;
	public catalogVersion: KnockoutObservable<string>;
	public user: KnockoutObservable<string>;
	public userInfoFormatted = ko.computed(() => {
		//UserHelper.getInstance().extendedUserInformationFormatted();
		//console.log({ b4: UserHelper.getInstance().extendedUserInformationFormatted()});
		UserHelper.getInstance().loadExtendedUserInformationAsync();
		//console.log({ a: UserHelper.getInstance().extendedUserInformationFormatted() });

		return UserHelper.getInstance().extendedUserInformationFormatted();
	});
	public marketer: KnockoutObservable<string>;
	public marketerKey: KnockoutObservable<string>;
	public backup: KnockoutObservable<string>;
	public backupDate: KnockoutObservable<Date>;
	public isTestEnvironment: KnockoutObservable<boolean>;
	public colorValue1: KnockoutObservable<number>;
	public colorValue2: KnockoutObservable<number>;
	public color1: KnockoutObservable<string>;
	public color2: KnockoutObservable<string>;

	public getExtendedUserInformationFormatted() {
		UserHelper.getInstance().loadExtendedUserInformationAsync();
		return UserHelper.getInstance().extendedUserInformationFormatted;
	}

	public updateAsync() {
		let versionUrl = UrlHelper.getDataUrl("versioninfo");
		return ServiceProvider.ajax.getJsonNoCacheAsync({ url: versionUrl })
			.then((data) => {
				ConnectionInformationVm.getInstance().update(data);
			})
			.catch(() => {
				MessageHelper.uiError("Die Versionsinformationen konnten nicht aktualisiert werden");
			});
	}

	private update(connectionInfo: DbTypes.IDbConnectionInformation) {
		if (!connectionInfo) {
			return;
		}

		this.name(connectionInfo.name);
		this.webServer(connectionInfo.webServer);
		this.datasource(connectionInfo.datasource);
		this.catalog(connectionInfo.catalog);
		this.catalogVersion(connectionInfo.catalogVersion);
		this.user(connectionInfo.user);
		this.marketer(connectionInfo.marketer);
		this.marketerKey(connectionInfo.marketerKey);
		this.backup(connectionInfo.backup);
		this.backupDate(connectionInfo.backupDate);
		this.isTestEnvironment(connectionInfo.isTestEnvironment);
		this.colorValue1(connectionInfo.colorValue1);
		this.colorValue2(connectionInfo.colorValue2);
		this.color1(connectionInfo.color1);
		this.color2(connectionInfo.color2);
	}
}